<template>
  <div class="table-container">
    <div class="table">
      <TableHeader :columns="columns" :data-source="dataSource"></TableHeader>
      <TableRow
        v-for="(rowData, rowIndex) of dataSource.docs"
        :key="rowIndex"
        :data="rowData"
        :columns="columns"
        @click="onClickRow(rowData)"
      >
      </TableRow>
      <div v-if="dataSource.docs.length <= 0" class="table-row empty">
        <div class="table__placeholder--icon"></div>
        <p class="table__placeholder--text">{{ $t('tables.emptyDataResults') }}</p>
      </div>
    </div>
    <TablePaginator v-if="dataSource.docs.length > 0" :data-source="dataSource"></TablePaginator>
  </div>
</template>

<script>
import Column from './Column';
import TableDatasource from './TableDatasource';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import TablePaginator from './TablePaginator';

export default {
  name: 'Table',
  components: {
    TableHeader,
    TableRow,
    TablePaginator
  },
  props: {
    dataSource: {
      type: Object,
      default: () => new TableDatasource()
    },
    // data: {
    //   type: Array,
    //   default: () => []
    // },
    columns: {
      type: Array,
      default: function() {
        return this.data && this.data.length
          ? Object.keys(this.data[0]).map(
              (key) =>
                new Column({
                  value: key
                })
            )
          : [];
      }
    }
  },
  data() {
    return {
      selectOpen: false,
      showMenu: false
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh(params) {
      if (this.dataSource) {
        await this.dataSource.refresh(params);
      }
    },
    onClickRow(rowData) {
      this.$emit('clickRow', rowData);
    }
  }
};
</script>
